import themeVars from '@/assets/styles/variables.scss'

const plugin = {
  install(Vue) {
    // Expose Sass variables as globals for easy use in templates
    // @see https://vuejs.org/v2/cookbook/adding-instance-properties.html#Base-Example
    Vue.prototype.$themeVars = themeVars
  }
}

export default plugin
